import { UserPen } from "lucide-react";

import { TarefaTipo } from "@workflow/types";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { TarefaDTO } from "@/types/tarefa.type";

interface TarefaOrigemBannerProps {
  tarefa: TarefaDTO;
}

/**
 * Aviso de origem: só aparece nas tarefas do tipo GENERICA ("Tarefa do job"),
 * que são criadas manualmente por uma pessoa — para distingui-las das tarefas
 * geradas automaticamente pelo sistema a partir de um fluxo (solicitar AP,
 * questionar versão, etc.).
 */
export function TarefaOrigemBanner({ tarefa }: TarefaOrigemBannerProps) {
  if (tarefa.tipo !== TarefaTipo.GENERICA) return null;

  const autor = tarefa.criadoPor?.nome;

  return (
    <Alert variant="info">
      <UserPen />
      <AlertTitle>Tarefa criada manualmente</AlertTitle>
      <AlertDescription>
        {autor ? (
          <>
            Esta tarefa foi aberta por <strong className="font-semibold">{autor}</strong> e não{" "}
          </>
        ) : (
          "Esta tarefa foi aberta manualmente e não "
        )}
        foi gerada automaticamente pelo sistema. Por isso o conteúdo e as instruções são definidos
        por quem a criou.
      </AlertDescription>
    </Alert>
  );
}
